module.exports = __webpack_public_path__ + "img/mission-gfj-palm.jpg?c3ecb79d131d84a326cb51a67061c43b";